import { Link } from 'react-router-dom';

export function Footer({ role }) {
    return (
        <footer className="bg-slate-900 text-slate-400 border-t border-slate-800">
            <div className="max-w-screen-xl mx-auto px-4 sm:px-6 py-10">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Brand */}
                    <div>
                        <h3 className="text-white font-bold text-lg mb-3">FidelRun</h3>
                        <p className="text-sm leading-relaxed">La plateforme de cartes de fidélité digitales pour les commerçants.</p>
                        <p className="text-xs mt-3 text-slate-500">SARL DEALRUN — SIRET 895 350 783 00018</p>
                    </div>

                    {/* Legal */}
                    <div>
                        <h4 className="text-slate-200 font-semibold text-sm mb-3">Juridique</h4>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/mentions-legales" className="hover:text-emerald-400 transition-colors">Mentions légales</Link></li>
                            <li><Link to="/confidentialite" className="hover:text-emerald-400 transition-colors">Politique de confidentialité</Link></li>
                            {role !== 'merchant' && (
                                <li><Link to="/cgu-clients" className="hover:text-emerald-400 transition-colors">CGU Clients</Link></li>
                            )}
                            {role !== 'client' && (
                                <li><Link to="/cgu-professionnels" className="hover:text-emerald-400 transition-colors">CGU Professionnels</Link></li>
                            )}
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="text-slate-200 font-semibold text-sm mb-3">Contact</h4>
                        <ul className="space-y-2 text-sm">
                            <li><a href="tel:0693463628" className="hover:text-emerald-400 transition-colors">06 93 46 36 28</a></li>
                            <li><a href="mailto:digirun974@gmail.com" className="hover:text-emerald-400 transition-colors">digirun974@gmail.com</a></li>
                        </ul>
                    </div>

                    {/* Address */}
                    <div>
                        <h4 className="text-slate-200 font-semibold text-sm mb-3">Adresse</h4>
                        <p className="text-sm leading-relaxed">APT 7 Résidence ARKEA Sainte-Clotilde<br />33 Bd du Mahatma Gandhi<br />97490 Saint-Denis</p>
                    </div>
                </div>

                <div className="border-t border-slate-800 mt-8 pt-6 text-center text-xs text-slate-500">
                    &copy; {new Date().getFullYear()} FidelRun — SARL DEALRUN. Tous droits réservés.
                </div>
            </div>
        </footer>
    );
}
